import { useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../config.js';
import DataLoader from '../components/common/DataLoader.js';
import DetallMovimentComponent from '../components/common/DetallMoviment.js';

const DetallMoviment = () => {
  const { id: paramMovId, userapp } = useParams();
  const movId = paramMovId;

  const fetchFunction = (jwtToken, onData, onError, onFinally) => {
    axios.get(`${config.apiBaseUrl}/v1/moviment/${movId}`, {
      headers: { Authorization: `${jwtToken}` }
    })
      .then((response) => {
        onData(response);
      })
      .catch((err) => {
        onError(err, 'cargar datos');
      })
      .finally(() => onFinally());
  };

  return (
    <DataLoader id={movId} fetchFunction={fetchFunction}>
      {(data, onError) => {
        return <DetallMovimentComponent
          data={data}
          userapp={userapp}
       />;
      }}
    </DataLoader>
  );
};

export default DetallMoviment;
